export default __webpack_public_path__ + "static/media/github.677921db.svg";